import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { defaultCardSelection, getInfo, multipleAnswerForm, registerForm, singleAnswerForm, translateRoom, updateForm } from './functions';
import { questions } from './data';
import FloorQuestions from './floorQuestions';
import StairsQuestions from './stairsQuestions';
import WallsQuestions from './wallsQuestions';
import BaseboardQuestions from './baseBoardQuestions';
import PoolQuestions from './poolQuestions';
import CeilingQuestions from './ceilingQuestions';
import GuardrailQuestions from './guardrailQuestions';
import Modal from '@components/Modal';
import ReviewModal from './reviewModal';
import Loader from '@components/Loader';
import { formatEmail } from './formatEmail';
import CompleteFormResume from './completeFormResume';

const strongText = (t) => {
  return <span style={{ fontWeight: 'bold', color: 'white' }}>{t}</span>
}

const flashingOptions = [
  "Todos os muros",
  "Todas as platibandas",
  "Muros acima de altura X",
  "Todos os muros, exceto área de lazer",
  "Todos os muros, exceto térreo",
  "Todos os muros, exceto área de lazer e térreo",
  "Outro",
  "Definir Posteriormente"
];

const flashingMats = [
  "Aço Galvanizado",
  "Alumínio",
  "Argamassado com textura",
  "Argamassado com pintura",
  "Concreto",
  "Outro",
  "Definir Posteriormente"
];

const thresholdLocOptions = [
  "Todas",
  "Portas exteriores",
  "Entrada de aptos",
  "Divisão de ambientes dentro dos aptos",
  "Entrada de áreas de Lazer",
  "Divisão de ambientes dentro da área de lazer",
  "Encontro de pisos diferentes no apartamento",
  "Encontro de pisos diferentes na área de lazer",
  "Definir Posteriormente"
];

const thresholdMatsOptions = [
  "Pedra Natural",
  "Porcelanato",
  "Concreto",
  "PVC",
  "Peça Cerâmica",
  "Pastilha",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
]

const ClientForm = () => {
  const { project_id } = useParams();
  const [modalVisible, setModalVisible] = useState(false)
  const [formData, setFormData] = useState({});
  const [data, setData] = useState({ flashing: [], flashingMats: "", thresholdLocs: [], thresholdMats: "", user: { name: "", email: "" } });
  const [loading, setLoading] = useState(true);
  const [floorGroups, setFloorGroups] = useState([]);
  const [ceilingGroups, setCeilingGroups] = useState([]);
  const [guardrailGroups, setGuardrailGroups] = useState([]);
  const [stairsGroups, setStairsGroups] = useState([]);
  const [wallGroups, setWallGroups] = useState([])
  const [baseboardGroups, setBaseboardGroups] = useState([]);
  const [poolGroups, setPoolGroups] = useState([]);
  const [finished, setFinished] = useState(false)
  const [sendStatus, setSendStatus] = useState({
    sending: false,
    code: 0,
    sent: false
  })
  const [toggle, setToggle] = useState({
    flashing: true,
    threshold: true,
    pergola: true,
    sill: true,
    roof: true,
    parking: true,
    frames: true
  })
  const [confirmSend, setConfirmSend] = useState(false)
  const [missingMsg, setMissingMsg] = useState('')
  const [anwersView, setAnswersView] = useState(false)

  const getFormData = async () => {
    setLoading(true);
    const res = await getInfo(project_id)
    const { item } = res;
    setFormData({ ...item, flashing: [], flashingMats: "", });
    if (item.clientInfos) {
      setFinished(item.completed)
      setFloorGroups(item.clientInfos.floorGroups || []);
      setCeilingGroups(item.clientInfos.ceilingGroups || []);
      setGuardrailGroups(item.clientInfos.guardrailGroups || []);
      setStairsGroups(item.clientInfos.stairsGroups || []);
      setWallGroups(item.clientInfos.wallGroups || []);
      setBaseboardGroups(item.clientInfos.baseboardGroups || []);
      setPoolGroups(item.clientInfos.poolGroups || []);
      setData({ ...item.clientInfos })
    }
    setLoading(false)
  }

  useEffect(() => {
    if (project_id) {
      getFormData()
    }
  }, [])

  const handleDefaultChange = (e, path) => {
    if (finished) return;
    const { value } = e.target;
    setData(prevData => ({ ...prevData, [path]: value }))
  }

  const defaultQuestion = (label, options, path, checkInProject) => {
    const extraPath = path + "Extra"
    const obsField = path + "Obs"
    return <div className='question-container margin-bottom-8'>
      <p className='margin-tier-1'>{label}</p>
      <div className='project-includes-container margin-tier-2  margin-bottom-8'>
        {options.map(i => {
          if (i.toLowerCase() === "seguir descrição do projeto" && !formData.projRoomFull.includes(checkInProject)) {
            return null
          }
          return defaultCardSelection(i, data[path] === i, (e) => {
            handleDefaultChange({ target: { value: e } }, path)
          })
        })}
      </div>
      {data[path] === "Outro" && <>
        <label className='margin-tier-2 margin-top-8'>Outro: </label>
        <input type='text' value={data[extraPath]} onChange={(e) => handleDefaultChange(e, extraPath)} />
      </>
      }

      <p className="margin-tier-1">Observações</p>
      <input className="extra-field  margin-bottom-8" disabled={finished} placeholder="Observações" value={data[obsField]} type="text" onChange={(e) => handleDefaultChange(e, obsField)} />

    </div>
  }

  const handleSend = async (full) => {
    const info = { data, formData, guardrailGroups, floorGroups, stairsGroups, wallGroups, baseboardGroups, poolGroups, ceilingGroups }
    const emailInfo = formatEmail(info)
    setSendStatus(prev => ({ ...prev, sending: true }))
    const wallRooms = wallGroups.flatMap(i => i.rooms)
    const baseboardRooms = baseboardGroups.flatMap(i => i.rooms)
    const baseboardMissingRooms = wallRooms.filter(i => !baseboardRooms.includes(i))
    setBaseboardGroups(prev => ([
      ...prev,
      { rooms: [...baseboardMissingRooms], type: "Nenhum", height: "0", }
    ]
    ))
    const finalData = {
      ...data,
      guardrailGroups,
      floorGroups,
      stairsGroups,
      wallGroups,
      baseboardGroups,
      poolGroups,
      ceilingGroups,
    };
    console.log(finalData)
    const res = await updateForm(formData._id, finalData, full, emailInfo)
    setSendStatus(prev => ({ sending: false, code: res.status, sent: true }))

  }

  const handleFloorsChange = (groups) => {
    setFloorGroups(groups);
  };

  const handleCeilingChange = (groups) => {
    setCeilingGroups(groups);
  }

  const handleStairsChange = (groups) => {
    setStairsGroups(groups);
  };

  const handleGuardrailChange = (groups) => {
    setGuardrailGroups(groups);
  };

  const handleWallChange = (groups) => {
    setWallGroups(groups);
  }

  const handleBaseboardChange = (groups) => {
    setBaseboardGroups(groups);
  }

  const handlePoolsChange = (groups) => {
    setPoolGroups(groups);
  }

  const handleToggle = (field) => {
    setToggle(prev => ({ ...prev, [field]: !prev[field] }))
  }

  const simpleHeader = (label, field) => {
    return <div className='header-container'>
      <div className="flex" style={{ alignItems: "center" }}>
        <button
          style={{ width: "35px" }}
          className={`accordion-toggle ${toggle[field] ? "active" : ""}`}
          onClick={() => handleToggle(field)}
        />
        <h2 className="main-header">{label}</h2>
      </div>
    </div>
  }

  const checkIfComplete = () => {
    console.log("Checking if complete...");
    if (!data.user?.name || !data.user?.email) {
      setMissingMsg("Nome ou e-mail do usuário estão faltando");
      return true;
    }
    if (data.flashing.length === 0 || data.flashingMats === "") {
      setMissingMsg("Dados de rufos estão incompletos");
      return true;
    }
    if (data.thresholdLocs.length === 0 || data.thresholdMats === "") {
      setMissingMsg("Dados de soleiras estão incompletos");
      return true;
    }
    if (floorGroups.length === 0) {
      setMissingMsg("Grupos de pisos incompletos");
      return true;
    }
    if (ceilingGroups.length === 0) {
      setMissingMsg("Grupos de tetos incompletos");
      return true;
    }
    if (guardrailGroups.length === 0) {
      setMissingMsg("Grupos de guarda-corpos incompletos");
      return true;
    }
    if (stairsGroups.length === 0) {
      setMissingMsg("Grupos de escadas incompletos");
      return true;
    }
    if (wallGroups.length === 0) {
      setMissingMsg("Grupos de paredes incompletos");
      return true;
    }
    if (baseboardGroups.length === 0) {
      setMissingMsg("Grupos de rodapés incompletos");
      return true;
    }
    if (formData.projectHas.includes("Piscina") && poolGroups.length === 0) {
      setMissingMsg('Dados de piscinas estão incompletos')
      return true;
    }
    const allPaths = questions.map(i => {
      return i.questions.map(j => j.path);
    });
    if (allPaths.flat().some(path => {
      if ((path === "pergola" || path === "pergolaDif") && !formData.projectHas.includes("Pergolado")) {
        setMissingMsg('Dados de pergolado estão incompletos');
        return;
      };
      if (path === "frameType" && !formData.projectHas.includes("Molduras")) {
        setMissingMsg('Dados de molduras estão incompletos');
        return;
      };
      const isEmpty = data[path] === "" || data[path] === undefined;
      if (isEmpty) {
        console.log(`Dados de ${path} estão incompletos`);
      }
      return isEmpty;
    })) {
      return true;
    }
    setMissingMsg('ok')
    console.log("All checks passed");
    return false;
  }

  const handleChangeView = () => {
    setAnswersView(!anwersView);
  }

  const handleModal = () => {
    setModalVisible(!modalVisible)
    const isComplete = checkIfComplete();
  }


  return <div className={`cartesian-form ${finished ? "finished" : ""}`}>
    {modalVisible && <ReviewModal
      allData={{
        data: data,
        guardrailGroups,
        floorGroups,
        stairsGroups,
        wallGroups,
        baseboardGroups,
        poolGroups,
        ceilingGroups
      }}
      missingMsg={missingMsg}
      close={handleModal}
    >
      {sendStatus.sending && <Loader />}
      {sendStatus.sent && <div className={`alert alert-${sendStatus.code === 200 ? "success" : "error"} margin-top-32`}>
        <h3 className="info-title">{sendStatus.code === 200 ? "Enviado com sucesso!" : "Erro ao enviar"}</h3>
        <p style={{ color: "black" }}>{sendStatus.code === 200 ? "As informações foram enviadas com sucesso." : "Ocorreu um erro ao enviar as informações."}</p>
      </div>}
      {!finished && <div className='flex justify-end gap-32 margin-top-32'>
        {confirmSend ? <>
          <p style={{ color: 'black' }}>Ao enviar por completo não serão mais permitidas alterações, deseja finalizar o formulário?</p>
          <button className='button button-error' onClick={() => setConfirmSend(false)}>Cancelar</button>
          <button className='button button-secondary' onClick={() => handleSend(true)}>Enviar</button>
        </>
          :
          <>
            <button className='button button-error' onClick={() => setModalVisible(false)}>Cancelar</button>
            <button className='button button-secondary' onClick={() => handleSend(false)}>Salvar e continuar depois</button>
            <button className='button button-secondary' onClick={() => setConfirmSend(true)} title={missingMsg !== "ok" ? missingMsg : "Enviar"} disabled={missingMsg !== 'ok'}>Enviar completo</button>
          </>}


      </div>}

    </ReviewModal>}
    {loading ? <p>Carregando obra</p> :
      <>
        {(finished || anwersView) ? <CompleteFormResume form={formData} handleChangeView={handleChangeView} /> : <div>
          <h1>{formData.name}{finished && " - Cadastro finalizado"}</h1>
          <p className='change-view' onClick={handleChangeView}>Visualizar informações já respondidas</p>
          <div className='form-section'>
            <h2>Instruções:</h2>
            <p>• Este formulário tem como objetivo orientar a equipe de orçamentos sobre quais materiais e revestimentos devem ser considerados no orçamento do projeto;</p>
            <p>• Utilize o botão {strongText('envio parcial')} para salvar os preenchimentos e continuar o preenchimento em outro momento;</p>
            <p>• Utilize o botão {strongText('envio completo')} quando tudo estiver preenchido. (A equipe Cartesian só utilizará as informações após o envio completo, para garantir que não hajam alterações);</p>
            <p>• Caso alguma alteração seja necessária após o envio completo, comunique a equipe Cartesian para liberação do formulário;</p>
            <p>• {strongText('IMPORTANTE: Preencha todas as perguntas, mesmo que o revestimento em questão não vá ser executado, utilize a resposta NENHUM nestes casos, não deixe a resposta em branco. Caso contrário, o envio completo não poderá ser feito.')}</p>
          </div>
          <div className='form-section'>
            <h2>Informações de contato:</h2>
            <div className='group-questions-container'>
              <div className=' gap-16'>
                <p>Nome:</p>
                <input type='text' value={data.user?.name} onChange={(e) => setData(prevData => ({ ...prevData, user: { ...prevData.user, name: e.target.value } }))} />
              </div>
              <div className=' gap-16'>
                <p>E-mail:</p>
                <input type='text' value={data.user?.email} onChange={(e) => setData(prevData => ({ ...prevData, user: { ...prevData.user, email: e.target.value } }))} />
              </div>
            </div>
          </div>
          {questions.map(i => {
            if (
              (i.label === "Molduras" && !formData.projectHas.includes("Molduras")) ||
              (i.label === "Pergolado" && !formData.projectHas.includes("Pergolado"))
            ) return;
            return <div className='form-section'>
              <div>
                {simpleHeader(i.label, i.toggleField)}
                {toggle[i.toggleField] &&
                  <div className='group-questions-container'>
                    {i.questions.map(({ label, path, options, toCheck }) => {
                      return defaultQuestion(label, options, path, toCheck)
                    })}
                    {i.hasExtra && <div className='question-container'>
                      <label>Caso algum ambiente utilize um material diferente, especifique: </label>
                      <input className='extra-field' type='text' placeholder='Ambiente - Material' value={data[i.extraPath]} onChange={(e) => handleDefaultChange(e, i.extraPath)} />
                    </div>}
                    {(i.label === "Molduras" && data.frameType === "Engrossamento de reboco") && <div className='question-container'>
                      <label>Especifique a espessura: </label>
                      <input className='extra-field' type='text' placeholder='Espessura' value={data.frameThickness} onChange={(e) => handleDefaultChange(e, "frameThickness")} />
                    </div>}

                  </div>
                }
              </div>
            </div>
          })}

          <div className='form-section'>
            {simpleHeader("Rufos", "flashing")}
            {toggle.flashing &&
              <div className='group-questions-container'>
                <div className='question-container'>
                  <p className="margin-tier-1">Onde devem ser considerados rufos?</p>
                  <div className="margin-bottom-16">
                    <div className="project-includes-container margin-tier-2 margin-bottom-8">
                      {flashingOptions.map(i => {
                        if (i?.toLowerCase() === "seguir descrição do projeto" && !fullDesc.includes(toCheckDef)) {
                          return null
                        }
                        return defaultCardSelection(i, data?.flashing?.includes(i), () => {
                          if (finished) return;
                          const newFlashing = [...data.flashing]
                          // if (i === "Todos os muros") {
                          //   if (flashingOptions.slice(0, 6).toString() === data.flashing.toString()) {
                          //     setData(prevData => ({ ...prevData, flashing: [] }));
                          //   } else {
                          //     setData(prevData => ({ ...prevData, flashing: flashingOptions.slice(0, 6) }));
                          //   }
                          //   return;
                          // }
                          if (data?.flashing?.includes(i)) {
                            setData(prevData => ({ ...prevData, flashing: newFlashing.filter(j => j !== i) }));
                          } else {
                            newFlashing.push(i);
                            setData(prevData => ({ ...prevData, flashing: newFlashing }));
                          }
                        })
                      })}

                    </div>
                  </div>
                  {data.flashing.includes("Outro") &&
                    <div className="margin-tier-2 margin-bottom-8">
                      <label>Outro: </label> <input type="text" onChange={(e) => setData(prev => ({ ...prev, flashingExtra: e.target.value }))} />
                    </div>
                  }
                  {data.flashing.includes("Muros acima de altura X") &&
                    <div className="margin-tier-2 margin-bottom-8">
                      <label>Muros acima de quantos CM? </label> <input type="text" value={data.flashingHeight} placeholder='Altura em centímetros' onChange={(e) => handleDefaultChange(e, 'flashingHeight')} />
                    </div>
                  }
                </div>
                {defaultQuestion("Qual material dos rufos?", flashingMats, "flashingMats")}
              </div>
            }
          </div>

          <div className='form-section'>
            {simpleHeader("Soleiras", "threshold")}
            {toggle.threshold &&
              <div className='group-questions-container'>
                <div className='question-container'>
                  <p className="margin-tier-1">Em quais portas usar soleira?</p>
                  <div className="margin-bottom-16">
                    <div className="project-includes-container margin-tier-2 margin-bottom-8">
                      {thresholdLocOptions.map(i => {
                        if (i?.toLowerCase() === "seguir descrição do projeto" && !formData.projRoomFull.includes("Soleiras nas Portas")) {
                          return null
                        }
                        return defaultCardSelection(i, data?.thresholdLocs?.includes(i), () => {
                          const newThresholdLocs = [...data.thresholdLocs]
                          if (finished) return;
                          if (i === "Todas") {
                            if (thresholdLocOptions.slice(0, 8).toString() === data.thresholdLocs.toString()) {
                              setData(prevData => ({ ...prevData, thresholdLocs: [] }));
                            } else {
                              setData(prevData => ({ ...prevData, thresholdLocs: thresholdLocOptions.slice(0, 8) }));
                            }
                            return;
                          }
                          if (data?.thresholdLocs?.includes(i)) {
                            setData(prevData => ({ ...prevData, thresholdLocs: newThresholdLocs.filter(j => j !== i) }));
                          } else {
                            newThresholdLocs.push(i);
                            setData(prevData => ({ ...prevData, thresholdLocs: newThresholdLocs }));
                          }
                        })
                      })}

                    </div>
                  </div>
                </div>

                {defaultQuestion("Qual o material?", thresholdMatsOptions, "thresholdMats", "Soleiras nas Portas")}
              </div>
            }
          </div>

          <h2>Informações em grupos</h2>
          <p>Para os próximos campos, siga as seguintes instruções:</p>
          <ol style={{ marginTop: '0px', color: 'white' }}>
            <li>Selecione os ambientes que vão compartilhar as mesmas especificações.</li>
            <li>Clique em Finalizar Grupo.</li>
            <li>Responda as perguntas.</li>
            <li>Repita até que não sobrem ambientes.</li>
          </ol>

          {formData.projectHas.includes("Piscina") &&
            <PoolQuestions pools={formData.roomDefinitions.pools} onGroupsChange={handlePoolsChange} formData={formData} preGroup={poolGroups} finished={finished} />
          }

          <GuardrailQuestions guardrail={formData.roomDefinitions.guardrail} onGroupsChange={handleGuardrailChange} formData={formData} preGroup={guardrailGroups} finished={finished} />


          <FloorQuestions floors={formData.roomDefinitions.floors} onGroupsChange={handleFloorsChange} formData={formData} preGroup={floorGroups} finished={finished} />

          <CeilingQuestions ceilings={formData.roomDefinitions.ceiling} onGroupsChange={handleCeilingChange} formData={formData} preGroup={ceilingGroups} finished={finished} />

          <WallsQuestions walls={formData.roomDefinitions.wallsRevest} onGroupsChange={handleWallChange} formData={formData} preGroup={wallGroups} finished={finished} />

          <BaseboardQuestions walls={wallGroups} baseboards={formData.roomDefinitions.baseboards} onGroupsChange={handleBaseboardChange} formData={formData} preGroup={baseboardGroups} finished={finished} />

          <StairsQuestions stairs={formData.roomDefinitions.stairs} onGroupsChange={handleStairsChange} formData={formData} preGroup={stairsGroups} finished={finished} />

        </div>}
      </>

    }
    <button onClick={handleModal} className="button button-accent send-button">Enviar</button>
  </div>
}

export default ClientForm;